import { render, staticRenderFns } from "./releaseOpportunity.vue?vue&type=template&id=144ed94d&scoped=true&"
import script from "./releaseOpportunity.vue?vue&type=script&lang=js&"
export * from "./releaseOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./releaseOpportunity.vue?vue&type=style&index=0&id=144ed94d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144ed94d",
  null
  
)

export default component.exports